import FormSimilar from './FormSimilar'
import FormSymbol from './FormSymbol'
import FormWord from './FormWord'
import Homophone from './Homophone'
import RightWord from './RightWord'
import SoundSymbol from './SoundSymbol'

export default {
  'form-similar': FormSimilar,
  'form-symbol': FormSymbol,
  'form-word': FormWord,
  'homophone': Homophone,
  'right-word': RightWord,
  'sound-symbol': SoundSymbol,
}
